import axios from 'axios'
import constants from '../lib/constants'

// CONSTANTS
export const GET_PHARMACIES = 'GET_PHARMACIES'
export const GET_PHARMACIES_COMPLETE = 'GET_PHARMACIES_COMPLETE'

// ACTIONS
let TOKEN = localStorage.getItem('authToken')

if (TOKEN) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`
}

export const getPharmacies = () => {
  return (dispatch, getState) => {
    dispatch({ type: GET_PHARMACIES })
    return axios.get(`${constants.API_URL}/pharmacies/list`)
    .then((response) => {
      const sortedPharmacies = response.data.pharmacies.sort((a, b) => (a.name > b.name ? 1 : -1))
      dispatch({
        type    : GET_PHARMACIES_COMPLETE,
        payload : {
          pharmacies: sortedPharmacies,
        }
      })
      return response
    })
  }
}

// ACTION HANDLERS

const ACTION_HANDLERS = {
  [GET_PHARMACIES_COMPLETE] : (state, action) => {
    const { pharmacies } = action.payload
    const newState = {
      ...state,
      pharmacies
    }
    return newState
  }
}

// REDUCER

const initialState = {
  pharmacies: []
}

export default function pharmaciesReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/pharmacies.js